<div class="h-full w-full relative">
  
  <canvas
    baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="barChartType"
  ></canvas>
</div>
